<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click.prevent="toogleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout row wrap body-1>
                <v-flex xs12 py-0>
                  <span class="color-dark-blue font-weight-bold uppercase">{{ companyName }}</span>
                  <span class="caption">{{ companyDocument }}</span>
                  <span v-if="record.from_chargeback" class="color-light-red font-weight-bold uppercase">MED</span>
                </v-flex>
                <v-flex xs12 py-0>
                  Valor: {{ wire_value }} Transações: {{ record.count }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 py-0 text-xs-right>
              <v-layout row wrap caption>
                <v-flex xs12 py-0>
                  {{ longAccountName(record.receiver) }}
                </v-flex>
                <v-flex xs12 py-0>
                  {{ longAccountName(record.receiver.intermediary_bank_account) }}
                  <div>Cliente: {{ partnerName }}</div>
                </v-flex>
              </v-layout>
            </v-flex>

            <exchange :record="exchange" v-for="exchange in exchanges" :key="exchange.id" v-if="current_view === 'detailed'" cursor-default />

            <transition name="fade">
              <v-flex pt-3 xs12 v-if="current_view === 'detailed'" cursor-default>
                <v-layout row wrap body-1>
                  <v-flex xs12 lg6 p-0 m-0 @click.prevent.stop="">
                    <v-autocomplete
                      v-model="fromAccountId"
                      clearable
                      :placeholder="i18n('Pesquise pelo número da conta ou apelido')"
                      @click:clear="clearAutocomplete"
                      :no-data-text="noDataText"
                      :items="fromAccountSelect"
                      :label="fromAccountLabel"
                      v-on:keyup.enter="findBankAccountByNumberOrNickname($event)"></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 lg3 p-0 m-0 pl-1 @click.prevent.stop="">
                    <v-btn @click="exportTransactionCsvForBank" block dark class="ma-0 btn-style--secondary">
                      CSV Banco
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 lg3 p-0 m-0 pl-1 @click.prevent.stop="">
                    <v-btn @click="exportTransactionCsvForCustomer" block dark class="ma-0 btn-style--secondary">
                      CSV Cliente
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" adjust-btn-top-margin :class="{ 'cursor-default': disableCreateWire }" v-if="allowSmartbankTed && !record.from_chargeback">
                    <!--v-checkbox style="margin: 10px auto;" v-model="options" label="Realizar transferência automática via TED" value="automatic-ted" @change="validateAutomaticWireChoice('automatic-ted')" ></v-checkbox-->
                    <!--v-checkbox style="margin: 10px auto;" v-model="options" label="Realizar transferência automática via PIX (Letsbank) - válido até 25/12/23" value="automatic-pix-smartbank" @change="validateAutomaticWireChoice('automatic-pix-smartbank')" ></v-checkbox-->
                    <v-checkbox style="margin: 10px auto;" v-model="options" label="Realizar transferência automática via PIX (Genial)" value="automatic-pix-genial" @change="validateAutomaticWireChoice('automatic-pix-genial')"></v-checkbox>
                    <v-checkbox style="margin: 10px auto;" v-model="options" label="Realizar transferência automática via PIX (Facilita Bank)" value="automatic-pix-facilita-bank" @change="validateAutomaticWireChoice('automatic-pix-facilita-bank')"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" adjust-btn-top-margin :class="{ 'cursor-default': disableCreateWire }" v-else-if="record.from_chargeback">
                    <v-checkbox style="margin: 10px auto;" v-model="alwaysTrue" disabled label="Realizar transferência automática via PIX (Facilita Bank)" />
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" adjust-btn-top-margin :class="{ 'cursor-default': disableCreateWire }" v-if="allowSPEI">
                    <v-checkbox style="margin: 10px auto;" v-model="options" label="Realizar transferência automática via SPEI" value="automatic-spei" @change="validateAutomaticWireChoice('automatic-spei')"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" adjust-btn-top-margin :class="{ 'cursor-default': disableCreateWire }" v-if="allowCobre">
                    <v-checkbox style="margin: 10px auto;" v-model="options" label="Realizar transferência automática via Cobre" value="automatic-cobre" @change="validateAutomaticWireChoice('automatic-cobre')"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 v-on:mouseover.stop="" @click.prevent.stop="" adjust-btn-top-margin :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'normal'">
                    <v-btn @click="createWire" block dark class="ma-0 btn-style" :class="{ 'disable-events': disableCreateWire, 'cursor-default': disableCreateWire }">
                      Fechar Transferência
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 pt-4 pb-3 v-on:mouseover.stop="" @click.prevent.stop="" adjust-btn-top-margin v-if="mode === 'confirmation'" text-xs-center>
                    <h3>Tem certeza que deseja registrar a transferência?</h3>
                  </v-flex>
                  <v-flex xs6 p-0 m-0 pt-2 v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'confirmation'">
                    <v-btn @click="mode = 'normal'" block dark class="ma-0 btn-style">
                      Cancelar
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 p-0 m-0 pt-2 v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'confirmation'">
                    <v-btn @click="createWire" block dark class="ma-0 btn-style--tertiary" :class="{ 'disable-events': disableCreateWire, 'cursor-default': disableCreateWire }">
                      Fechar Transferência
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'creating'">
                    <v-btn block dark class="ma-0 btn-style--tertiary" :class="{ 'disable-events': disableCreateWire, 'cursor-default': disableCreateWire }">
                      Aguarde
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'errorCheckBalance'">
                    <h3>Não foi possível consultar o saldo da conta</h3>
                  </v-flex>
                  <v-flex xs6 p-0 m-0 pt-2 pl-1 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'errorCheckBalance'">
                    <v-btn @click="mode = 'normal'" block dark class="ma-0 btn-style">
                      Cancelar
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 p-0 m-0 pt-2 pl-1 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'errorCheckBalance'">
                    <v-btn @click="createWireBypassBalance" block dark class="ma-0 btn-style--tertiary" :class="{ 'disable-events': disableCreateWire, 'cursor-default': disableCreateWire }">
                      Fechar transferência sem consultar saldo
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'notEnoughBalance'">
                    <h3>Saldo de {{ this.balance }} insuficiente</h3>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 pl-1 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="mode === 'notEnoughBalance'">
                    <v-btn @click="mode = 'normal'" block dark class="ma-0 btn-style">
                      Cancelar
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 pt-2 text-xs-center v-on:mouseover.stop="" @click.prevent.stop="" :class="{ 'cursor-default': disableCreateWire }" v-if="['speiError', 'pixFacilitaBankError', 'cobreError'].includes(mode)">
                    <h3>Error: {{ this.smartbankTedErrorMsg }}</h3>
                  </v-flex>
                  <v-flex xs12 pt-4 pb-3 v-on:mouseover.stop="" @click.prevent.stop="" v-if="mode === 'created'" text-xs-center>
                    <h3>Transferência Registrada - ID: {{ this.createdWire.id }}</h3>
                    <h3 v-if="smartbankTedSuccess">Hash: {{ this.smartbankHash }}</h3>
                    <h3 v-if="smartbankTedError">Error: {{ this.smartbankTedErrorMsg }}</h3>
                  </v-flex>
                  <v-flex xs12 p-0 m-0 @click.prevent.stop="" v-if="mode === 'created'">
                    <v-btn @click="closeWire" block dark class="ma-0 btn-style--secondary">
                      Fechar
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import ExchangeItem from "./ExchangeItem"
import { BankAccountsApi } from '@/shared/BankAccountsApi'

export default {
  name: 'WireAccountItem',
  components: { 'exchange': ExchangeItem },
  props: {
    record: {
      type: Object
    },
    bank_accounts: {
      type: Array
    }
  },
  data() {
    return {
      alwaysTrue: true,
      noDataText: '',
      exchanges: [],
      partnerName: 'Loading...',
      exchangesLoaded: 'not_loaded',
      current_view: 'short',
      fromAccountId: null,
      mode: 'normal',
      submitting_data: false,
      createdWire: null,
      allowSmartbankTed: false,
      allowSPEI: false,
      allowCobre: false,
      options: [],
      smartbankTedError: false,
      smartbankTedErrorMsg: '',
      smartbankTedSuccess: false,
      smartbankHash: '',
      wire_value: '',
      bypassBalancePixWire: false,
      balance: null,
      fromAccountSelect: []
    }
  },
  computed: {
    receiver() {
      return this.record && this.record.receiver && this.record.receiver.company || 'N/A'
    },
    companyName() {
      return this.receiver.social_name || 'N/A'
    },
    companyDocument() {
      const document_type = this.receiver.document_type || false
      if (!document_type) return ''
      return document_type.toUpperCase() + ' ' + utils.mask(document_type, this.receiver.document_number)
    },
    disableCreateWire() {
      if (this.fromAccountId === null) return true
      if (this.fromAccountId === '') return true

      return false
    },
    fromAccountLabel() {
      return `Conta ${this.record.receiver.currency}`
    }
  },
  methods: {
    mask(format, value) {
      return utils.mask(format, value)
    },
    toogleView() {
      this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
    },
    calculate_wire_tax() {
      let value = this.record.value
      let exchange = this.exchanges[0]
      const company_id = exchange.bank_transactions[0].scheduled_bank_transaction.company.id
      const currency = exchange.currency
      const exchange_currency = exchange.exchange_currency
      const for_bank_account_id = exchange.to_bank_account.id
      const is_local_currency_payment = this.$root.local_currencies.includes(exchange_currency)
      const is_crypto_currency_payment = this.$root.crypto_currencies.includes(exchange_currency)

      if (is_local_currency_payment || is_crypto_currency_payment) {
        this.wire_value = utils.currencyToLocal(value, exchange_currency)
        return
      }

      let successCallback = (response) => {
        const sent_wire_tax = response.body.data && response.body.data.sent_wire_tax

        if (sent_wire_tax && sent_wire_tax.debited) {
          value = value - sent_wire_tax.value
        }

        this.wire_value = utils.currencyToLocal(value, exchange_currency)
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      let url = this.$root.urls.admin__company_taxes.split('ID').join(company_id)
      const params = { "currency": currency, "exchange_currency": exchange_currency, "for_bank_account_id": for_bank_account_id, "operation_value": value }
      this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    longAccountName(account) {
      if (account === null) { return '' }
      return utils.longAccountName(account)
    },
    accountSelect(currency) {
      let bank_accounts = this.bank_accounts.filter((record) => { return record.currency == currency })
      return bank_accounts.map(o => { return { text: utils.shortAccountName(o), value: `${o.id}` } })
    },
    exportTransactionCsvForCustomer() {
      utils.exportTransactionCsvForCustomer(this.exportTransactionCsv, this.createdWire)
    },
    exportTransactionCsvForBank() {
      utils.exportTransactionCsvForBank(this.exportTransactionCsv)
    },
    exportTransactionCsv(header_line, pushLine, separator) {
      let exchanges_transactions = this.exchanges.reduce((exchange_acc, exchange) => {
        exchange.bank_transactions.forEach((bank_transaction) => {
          pushLine(bank_transaction, exchange_acc)
        })
        return exchange_acc
      }, [header_line])

      const filename = this.createdWire
        ? `wire-${this.createdWire.id}.csv`
        : 'wire-unregistered.csv';

      utils.exportToCsv(filename, exchanges_transactions, separator)
    },

    waitForExchangesInfo() {
      setTimeout(() => {
        if (!this.record.exchanges) {
          this.waitForExchangesInfo()
        } else {
          this.exchanges = this.record.exchanges.map(o => { o.selected = true; return o })
          this.partnerName = Object.values(this.getPartnersFromExchanges(this.exchanges)).join(',')
          this.exchangesLoaded = 'ok'
          this.calculate_wire_tax()
        }
      }, 250);
    },
    closeWire() {
      if (this.mode == 'created') {
        this.$emit('wireCreated', this.record.receiver.id, this.record.exchange_ids, this.createdWire)
      }
    },
    createWire() {
      if (this.disableCreateWire) { return }
      if (this.submitting_data) { return }

      if (this.mode == 'normal') {
        this.mode = 'confirmation'
        return null
      } else {
        this.mode = 'creating'
      }

      let successCallback = (response) => {
        if (response.body.data) {
          if (response.body.ted && response.body.ted.error) {
            this.smartbankTedErrorMsg = response.body.ted.error
            this.smartbankTedError = true
          }
          if (response.body.ted && response.body.ted.data && response.body.ted.data.hash) {
            this.smartbankHash = response.body.ted.data.hash
            this.smartbankTedSuccess = true
          }
          if (response.body.pix && response.body.pix.error) {
            this.smartbankTedErrorMsg = response.body.pix.error
            this.smartbankTedError = true
          }
          if (response.body.pix && response.body.pix.data && response.body.pix.data.hash) {
            this.smartbankHash = response.body.pix.data.hash
            this.smartbankTedSuccess = true
          }
          if (response.body.spei && response.body.spei.error) {
            this.smartbankTedErrorMsg = response.body.spei.error
            this.smartbankTedError = true
          }
          if (response.body.spei && response.body.spei.data && response.body.spei.data.id) {
            this.smartbankHash = response.body.spei.data.id
            this.smartbankTedSuccess = true
          }
          this.mode = 'created'
          this.createdWire = response.body.data
        }
      }

      let errorCallback = (response) => {
        this.submitting_data = false
        if (response.status === 422) {
          if (response.body.error && response.body.error.message === "Not enough balance") {
            const currency = this.record.receiver.currency

            if (["MXN", "COP"].includes(currency)) {
              this.balance = utils.currencyToLocal(response.body.error.balance, currency)
            } else {
              this.balance = utils.currencyToLocal(response.body.error.balance, "BRL")
            }
            this.mode = "notEnoughBalance"
          } else if (response.body.error && response.body.error === "Unavailable service") {
            this.mode = 'errorCheckBalance'
          } else if (response.body.pix && response.body.pix.data.error == "bank not found") {
            this.mode = 'pixFacilitaBankError'
            this.smartbankTedErrorMsg = response.body.pix.data.error
          } else if (response.body.cobre && response.body.cobre.error) {
            this.mode = 'cobreError'
            this.smartbankTedErrorMsg = response.body.cobre.error
          } else if (response.body && response.body.spei) {
            this.mode = 'speiError'
            if (response.body.spei.error.receiver_institution_number) {
              this.smartbankTedErrorMsg = "to_bank_account has an invalid account_number"
            } else {
              this.smartbankTedErrorMsg = response.body.spei.error
            }
          }
        } else {
          console.log('errorCallback', response)
          this.mode = 'error'
          this.submitting_data = false
        }
      }

      let payload = {
        company_wire: {
          to_bank_account_id: this.record.receiver.id,
          from_bank_account_id: this.fromAccountId,
          currency: this.record.receiver.currency,
          value: this.record.value,
          exchange_ids: this.record.exchange_ids
        }
      }

      if (this.options.includes('automatic-pix-genial')) {
        payload.company_wire.automatic = 'pix'
        payload.company_wire.bypass_check_balance_facilita_bank_account = this.bypassBalancePixWire
      } else if (this.options.includes('automatic-pix-smartbank')) {
        payload.company_wire.automatic = 'pix_smartbank'
        payload.company_wire.bypass_check_balance_facilita_bank_account = this.bypassBalancePixWire
      } else if (this.options.includes('automatic-ted')) {
        payload.company_wire.automatic = 'ted'
      } else if (this.options.includes('automatic-spei')) {
        payload.company_wire.automatic = 'spei'
        payload.company_wire.bypass_check_balance_facilita_bank_account = this.bypassBalancePixWire
      } else if (this.options.includes('automatic-cobre')) {
        payload.company_wire.automatic = 'cobre'
        payload.company_wire.bypass_check_balance_facilita_bank_account = this.bypassBalancePixWire
      } else if (this.options.includes('automatic-pix-facilita-bank')) {
        payload.company_wire.automatic = 'facilita_bank'
        payload.company_wire.bypass_check_balance_facilita_bank_account = this.bypassBalancePixWire
      }

      this.submitting_data = true
      let token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin__company_wires, payload, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    createWireBypassBalance() {
      this.bypassBalancePixWire = true
      this.createWire()
    },
    getPartnersFromExchanges(exchanges) {
      let result = {}
      exchanges.forEach((exchange) => {
        exchange.bank_transactions.forEach((bank_transaction) => {
          result[bank_transaction.scheduled_bank_transaction.company.id] = bank_transaction.scheduled_bank_transaction.company.social_name
        })
      })
      return result
    },
    validateAutomaticWireChoice(field) {
      this.options = this.options.filter((option) => option == field)
    },

    findBankAccountByNumberOrNickname(event) {
      let successCallback = (response) => {
        this.fromAccountSelect = response.body.data.map(o => { return { text: utils.shortAccountName(o), value: o.id } })
        this.setEmptyTextLabelIfRequired()
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.companyLoaded = 'not_authorized'
        } else {
          this.companyLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      BankAccountsApi.loadBankAccountByNumberOrNickname(this, this.$root.urls.admin__user__bank_accounts, successCallback, errorCallback, event.srcElement.value);
    },
    setDefaultNoTextLabel() {
      this.noDataText = this.i18n('Digite pelo menos 3 caracteres e tecle enter')
    },
    setEmptyTextLabelIfRequired() {
      if (this.fromAccountSelect.length == 0) {
        this.noDataText = this.i18n('Nenhum registro encontrado')
      }
    },
    clearAutocomplete() {
      this.fromAccountSelect = [];
      this.setDefaultNoTextLabel()
    },
    i18n(str) {
      return this.$root.l(str)
    },
  },
  mounted() {
    this.fromAccountSelect = this.accountSelect(this.record.receiver.currency);
    this.setDefaultNoTextLabel()
    this.waitForExchangesInfo()
    if (this.fromAccountSelect[0]) {
      this.fromAccountId = this.fromAccountSelect[0].value
    }
    if (this.record.receiver.currency === 'BRL') {
      this.allowSmartbankTed = true
    }
    if (this.record.receiver.currency === 'MXN') {
      this.allowSPEI = true
    }
    if (this.record.receiver.currency === 'COP') {
      this.allowCobre = true
    }
  }
}
</script>
<style>
.adjust-btn-top-margin {
  margin-top: -28px;
}

.disable-events {
  pointer-events: none;
}

.cursor-default {
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/WireAccountItem.vue